import * as React from 'react';

import {
  CommonIconProps,
  IconSize,
  iconSideSizes
} from 'shared/entities/components/Icon';
import agentPlatformImg from 'shared/img/agentPlatformImg.png';

const AgentPlatformIcon: React.FC<CommonIconProps> = ({
  className,
  iconSize = IconSize.L
}: CommonIconProps) => {
  const size = iconSideSizes[iconSize];

  return (
    <img
      className={className}
      src={agentPlatformImg}
      width={size}
      height={size}
      alt="Agent Platform"
      style={{ borderRadius: 4 }}
    />
  );
};

export default AgentPlatformIcon;
